import { styled, Box } from 'bonfire-kindling';

const Page = styled(Box)(({ isTinted, theme }) => ({
  overflow: 'auto',
  height: '100%',
  ...(isTinted ? { background: theme.palette.background.main } : {}),
}));

export default Page;
